import { Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import PublicStatsPage from "./pages/PublicStatsPage";
import DashboardPage from "./pages/DashboardPage";
import WalletPage from "./pages/WalletPage";
import TradesPage from "./pages/TradesPage";
import TradeDetailPage from "./pages/TradeDetailPage";
import JourneyPage from "./pages/JourneyPage";
import CalendarPage from "./pages/CalendarPage";
import ImportPage from "./pages/ImportPage";
import ReportsPage from "./pages/ReportsPage";
import AssistantPage from "./pages/AssistantPage";
import SettingsPage from "./pages/SettingsPage";
import ProfilePage from "./pages/ProfilePage";
import AdminPage from "./pages/AdminPage";
import Shell from "./components/Shell";
import SetupWizard from "./components/SetupWizard";
import VerifyEmailPending from "./components/VerifyEmailPending";
import { AuthProvider, RequireAuth, useAuth } from "./lib/auth";
import { SettingsProvider, useSyncDisplayTz } from "./lib/settings";

function TzSync({ children }: { children: React.ReactNode }) {
  useSyncDisplayTz();
  return <>{children}</>;
}

// Authenticated layout gates, in order: an unconfirmed email must be verified
// first, then a brand-new user runs the setup wizard, then the normal app shell
// (with nested routes) renders.
function AuthedLayout() {
  const { emailVerified, needsOnboarding } = useAuth();
  if (!emailVerified) return <VerifyEmailPending />;
  return needsOnboarding ? <SetupWizard /> : <Shell />;
}

export default function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <TzSync>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/s/:token" element={<PublicStatsPage />} />
            <Route
              element={
                <RequireAuth>
                  <AuthedLayout />
                </RequireAuth>
              }
            >
              <Route path="/" element={<DashboardPage />} />
              <Route path="/wallet" element={<WalletPage />} />
              <Route path="/trades" element={<TradesPage />} />
              <Route path="/trades/:id" element={<TradeDetailPage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/journey" element={<JourneyPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/import" element={<ImportPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/assistant" element={<AssistantPage />} />
            </Route>
          </Routes>
        </TzSync>
      </SettingsProvider>
    </AuthProvider>
  );
}
